import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS = {
  80002: '0x57c21f8DBC66777aafdB12F19455F3cF27d4A2a1', //TODO: CHANGE THIS 0x5f98B0F5f1413C100A17ED7f8241B4457b412724
  137: '0x35e4aA226ce52e1E59E5e5Ec24766007bCbE2e7D',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
